import UiForm from "./UiForm";
import { EnumMiezzFormItemType, MiezzFormItem } from "@/models/MiezzForm";
import UiGroup from "./UiGroup";

/**
 * 付款条款内容表单
 * @description 自动生成的代码,请勿修改
 */
export default class DtoFormPaymentTermsContent extends UiForm<string> {
    constructor() {
        //无参构造函数
        super()
        this.UiGroups = [];
    }

    [proName: string]: any;
    /**
     * 名称
     */
    Name?: string;
    /**
     * 付款条款
     */
    PaymentTermsId?: string;
}

/**
 * 付款条款内容表单-表单校验
 */
export const DtoFormPaymentTermsContentRules = {
    Name: [
        {
            required: true,
            message: "信息不能为空",
            trigger: "blur",
        },
        {
            max: 128,
            message: "文本长度不能超过 128 个字符",
            trigger: "blur",
        },
    ],
}

/**
 * 付款条款内容表单-设置项
 */
export const DtoFormPaymentTermsContentMiezzFormItems: MiezzFormItem[] = [
  {
    Prop: "Name",
    Label: "名称",
    Type: EnumMiezzFormItemType.InputText,
  },
  {
    Prop: "PaymentTermsId",
    Label: "付款条款",
    Span: 24,
    Customize: true,
  },
]
